
<!-- Start Page Title Area -->
<div id="bg-cover" class="page-title-area page-title-style-two lightgray-bg jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li>{{coursesText}}</li>
            </ul>
            <h2>{{coursesText}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Courses Area -->
<section class="courses-area ptb-100">
    <div class="container">
        <div class="courses-topbar">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <div class="topbar-result-count">
                        <p>
                            {{ofRecords}} of {{totalRecords}}
                            <a (click)="onNext(false)" href="javascript:;" class="pre page-numbers"><i class='bx bx-chevron-left'></i></a>
                            <a (click)="onNext(true)" href="javascript:;" class="next page-numbers"><i class='bx bx-chevron-right'></i></a>
                        </p>
                        
                    </div>
                </div>

                <div class="col-lg-4 col-md-4">
                    <div class="topbar-ordering-and-search">
                        <div class="row align-items-center">
                            <!-- <div class="col-lg-3 col-md-5 offset-lg-4 offset-md-1 col-sm-6">
                                <div class="topbar-ordering">
                                    <select>
                                        <option>Sort by popularity</option>
                                        <option>Sort by latest</option>
                                        <option>Default sorting</option>
                                        <option>Sort by rating</option>
                                        <option>Sort by new</option>
                                    </select>
                                </div>
                            </div> -->

                            <div class="col-lg-12 col-md-6 col-sm-6">
                                <div class="topbar-search">
                                    <form>
                                        <label><i class="bx bx-search"></i></label>
                                        <input type="text" class="input-search" placeholder="{{searchHere}}">
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-small-spinner [show]="showSpinner"></app-small-spinner>
        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let course of courses">
                <app-course-item [course]="course" (routeToCourseDetail) = "routeToCourseDetail($event)">
                </app-course-item>
            </div>
        </div>
        <!-- <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="pagination-area text-center">
                <ul>
                    <li *ngFor="let item of numPages">
                        <span *ngIf="item.current; else other" class="page-numbers current" aria-current="page">{{item.index}}</span>
                        <ng-template #other>
                            <a (click)="routeToLink(item.index)" href="javascript:;" class="page-numbers">{{item.index}}</a>
                        </ng-template>
                    </li>
                    <li><a href="#" class="next page-numbers"><i class='bx bx-chevron-right'></i></a></li>
                </ul>
                
            </div>
        </div> -->
    </div>
</section>
<!-- End Courses Area -->
